<div class="checkout-plan-picker tw-pt-5">
  <form
    (ngSubmit)="updatePlan()"
    id="form.changePlanForm"
    role="form"
    name="form.changePlanForm"
    novalidate
  >
    <select-plan
      [(isUnlimitedPlan)]="isUnlimitedPlan"
      [(periodMonthly)]="periodMonthly"
      [displayCount]="displayCount"
      [planType]="planType"
      [subscriptionId]="subscriptionId"
      (selectedProductCodeChange)="updateProductCode($event)"
    >
    </select-plan>

    <div class="button-toolbar flex-row w-100 w-lg-75 mx-0 mx-lg-auto mb-5">
      <a
        rv-button
        variant="secondary"
        id="cancelButton"
        actionLink
        (click)="cancel()"
        class="tw-flex-1"
        >Cancel</a
      >
      <button
        rv-button
        type="submit"
        id="subscribeButton"
        class="tw-flex-1 mt-0"
      >
        Next
      </button>
    </div>
  </form>
</div>
